import React from 'react'

export default function MetricSection(props) {
  return(
    <div className="mt-3">
      <div className="mt-3 pt-3 section-title col-12" style={styles.title}>{props.title}</div>
      <div className="description text-align-left col-12">{props.description}</div>
      {props.metrics}
    </div>
  )
}

const styles = {

}